import { render, staticRenderFns } from "./InstantSwitch2RowEl.vue?vue&type=template&id=607eabc7&scoped=true&"
import script from "./InstantSwitch2RowEl.vue?vue&type=script&lang=ts&"
export * from "./InstantSwitch2RowEl.vue?vue&type=script&lang=ts&"
import style0 from "./InstantSwitch2RowEl.vue?vue&type=style&index=0&id=607eabc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607eabc7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
